<template>
    <div class="welcome_template" v-html="$user.hotel.welcome_template[$i18n.locale]"></div>
</template>

<script>
export default {
    data() {		
        return {
        }
    }
}
</script>

<style>
    #canspamBarWrapper {
        display: none !important;
    }

    .welcome_template * {
        margin: auto !important;
    }
</style>